module.exports = __webpack_public_path__ + "img/addIcon.f4fdca0b.svg";